import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import {
  Card,
  CardBody,
  Table,
  Spinner,
  Alert,
} from "reactstrap";
import { ADMIN_AUDIT_LOGS, API_TIMEOUT } from "../../utils";

const formatDate = (str) => {
  if (!str) return "-";
  try {
    const d = new Date(str);
    return d.toLocaleString("id-ID", {
      dateStyle: "short",
      timeStyle: "medium",
    });
  } catch {
    return str;
  }
};

const AuditLogsPage = ({ currentUser }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const isSuperAdmin =
    (currentUser?.peran || "").toString().toLowerCase() === "super admin";

  useEffect(() => {
    if (!isSuperAdmin) {
      setLoading(false);
      setError("Hanya Super Admin yang dapat mengakses halaman ini.");
      return;
    }
    const token = localStorage.getItem("token");
    if (!token) {
      setLoading(false);
      setError("Sesi telah berakhir. Silakan login kembali.");
      return;
    }
    axios
      .get(ADMIN_AUDIT_LOGS, {
        timeout: API_TIMEOUT,
        headers: { Authorization: `Bearer ${token}` },
        params: { limit: 500 },
      })
      .then((res) => {
        if (res.data?.success === 1 && Array.isArray(res.data.data)) {
          setLogs(res.data.data);
        } else {
          setError("Format data tidak valid.");
        }
      })
      .catch((err) => {
        const msg =
          err.response?.data?.message ||
          err.message ||
          "Gagal memuat audit logs.";
        setError(msg);
      })
      .finally(() => setLoading(false));
  }, [isSuperAdmin]);

  if (!isSuperAdmin) {
    return (
      <div>
        <h2 className="page-title">Audit Logs</h2>
        <Alert color="danger">{error || "Akses ditolak."}</Alert>
      </div>
    );
  }

  return (
    <div>
      <h2 className="page-title">Audit Logs</h2>
      <p className="text-muted mb-3">
        Daftar log aktivitas semua admin. Hanya Super Admin yang dapat melihat halaman ini.
      </p>

      {loading ? (
        <div className="d-flex justify-content-center py-5">
          <Spinner color="primary" />
        </div>
      ) : error ? (
        <Alert color="danger">{error}</Alert>
      ) : (
        <Card>
          <CardBody>
            <Table responsive hover size="sm">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Waktu</th>
                  <th>Admin</th>
                  <th>Action</th>
                  <th>Route</th>
                  <th>Method</th>
                  <th>IP</th>
                </tr>
              </thead>
              <tbody>
                {logs.length === 0 ? (
                  <tr>
                    <td colSpan={7} className="text-center text-muted py-4">
                      Belum ada data audit logs.
                    </td>
                  </tr>
                ) : (
                  logs.map((row, i) => (
                    <tr key={row.id || i}>
                      <td>{row.id}</td>
                      <td>{formatDate(row.created_at)}</td>
                      <td>{row.admin_nama || "-"}</td>
                      <td>
                        <code className="small">{row.action || "-"}</code>
                      </td>
                      <td>
                        <span className="text-truncate d-inline-block" style={{ maxWidth: 220 }}>
                          {row.route || "-"}
                        </span>
                      </td>
                      <td>{row.method || "-"}</td>
                      <td>{row.ip_address || "-"}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      )}
    </div>
  );
};

const mapStateToProps = (store) => ({
  currentUser: store.auth?.currentUser || JSON.parse(localStorage.getItem("user") || "null"),
});

export default connect(mapStateToProps)(AuditLogsPage);
